/**
 * Build-time version constants.
 *
 * Both values are injected by Vite at build time (see `vite.config.ts`):
 *   - APP_VERSION ← package.json `"version"` field
 *   - GIT_SHA    ← `git rev-parse --short HEAD` (or VERCEL_GIT_COMMIT_SHA on Vercel)
 *
 * Stop manually editing this file. To bump:
 *   npm version patch        # 1.0.139 → 1.0.140 in package.json
 *   npm version minor        # 1.0.139 → 1.1.0
 * The injected APP_VERSION here will pick it up on the next build.
 */

// __APP_VERSION__ + __GIT_SHA__ are global string constants injected by
// Vite via `define`. The declarations live in src/vite-env.d.ts.
export const APP_VERSION: string = __APP_VERSION__
export const GIT_SHA: string = __GIT_SHA__

/** Display string for headers, footers, and version chips. */
export const APP_VERSION_FULL: string = GIT_SHA === 'dev'
  ? `${APP_VERSION} · dev`
  : `${APP_VERSION} · ${GIT_SHA}`

// Comment-only touch, no behavior change: azure-preview.yml only triggers on
// pull_request when web/src/**, web/api/** or server/** changes. This PR
// otherwise only touches .github/workflows/** and web/package.json, which
// would not exercise the new tesseract-github-preview identity end to end
// before merge. See PR #29.
